import axiosInstance from './axios.service'
import BaseUrl from "./url.service"

const serverUrl = `${BaseUrl}/advertisement`


export const getAllPromotions = async (query) => {
    return axiosInstance.get(`${serverUrl}/?${query}`)
}

export const getById = async (id) => {
    return axiosInstance.get(`${serverUrl}/getById/${id}`)
}

export const deleteAdvertisement = async (id) => {
    return axiosInstance.delete(`${serverUrl}/deleteById/${id}`)
}

export const AddAdvertisement = async (obj) => {
    return axiosInstance.post(`${serverUrl}/createAdvertisement`, obj)
}
export const updatePromotion = (formData, id) => {
    return axiosInstance.patch(`${serverUrl}/updateById/${id}`, formData)
  }
  